import {
  TComponentValue,
} from '@/types/openapi-type.ts';

type TNextState = Exclude<TComponentValue<'MaintenanceState'>, 'PENDING' | 'REJECTED'>;
type TPrevState = Exclude<TComponentValue<'MaintenanceState'>, 'COMPLETED' | 'IN_REVIEW'>;
type TStageChangeButtons = {
  next: Record<TNextState, string>,
  previous: Record<TPrevState, string>,
};

const stateChangeButtons: TStageChangeButtons = {
  next: {
    // PENDING -> ASSIGNED
    ASSIGNED: 'Accept work',
    // ASSIGNED -> IN_PROGRESS
    IN_PROGRESS: 'Start work',
    // IN_PROGRESS -> IN_REVIEW
    IN_REVIEW: 'Finish work',
    // IN_REVIEW -> COMPLETED
    COMPLETED: 'Approve work',
  },
  previous: {
    // ASSIGNED -> PENDING
    PENDING: 'Reject work',
    // IN_PROGRESS -> ASSIGNED
    ASSIGNED: 'Abort work',
    // IN_REVIEW -> IN_PROGRESS
    IN_PROGRESS: 'Reject work',
    // IN_REVIEW -> REJECTED
    REJECTED: 'Reject work',
  },
};

export default {
  stateChangeButtons,
};
